import { Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './table-filter.module.scss';

const caseTrackingDateInput = (startDate: Date | null, endDate: Date | null) => {
  const formatDate = (date: Date | null) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year} - ${month} - ${day}`;
  };

  const getDisplayText = () => {
    if (!startDate && !endDate) {
      return 'Date created';
    }

    if (startDate && !endDate) {
      return `${formatDate(startDate)} -`;
    }

    if (startDate && endDate) {
      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }

    return 'Date created';
  };

  return (
    <div className={styles.customDatePickerInput}>
      <Typography
        className={!startDate && !endDate ? styles.placeholder : ''}
        color={Typography.COLOR.TERTIARY}
      >
        {getDisplayText()}
      </Typography>
      <Icon icon={ICONS_ENUM.ACTION_CALENDAR_TODAY} className={styles.customDatePickerIcon} />
    </div>
  );
};

export default caseTrackingDateInput;
